import React, { Component } from "react";
import { Segment, Divider, Grid } from "semantic-ui-react";
import axios from "axios";

import Item from "./components/item";
import Presentation from "./components/presentation";
import SocialMedia from "./components/socialMedia";

import config from "../../config";
import authenticatedFetch from "../../services/authenticatedFetch";

class ProfilPage extends Component {
  state = {
    photoUrl: "",
    name: "",
    mail: "",
    buildingName: "",
    telPro: "",
    mobilePro: "",
    otherPhones: "",
    office: "",
    affectations: "",
    description: "",
    socialMedia : {
      linkedin: "",
      hal: "",    
      twitter: "",
      youtube: "",
      url: ""
    } 
  };

  componentDidMount() {
    this.fetchProfilData();
  }

  fetchProfilData = () => {
    authenticatedFetch(`uid/${this.props.match.params.uid}`)
      .then(data =>
        this.setState({
          title: data[0].title,
          photoUrl: data[0].photoUrl,
          name: data[0].displayName,
          mail: data[0].mail,
          buildingName: data[0].buildingName,
          telPro: data[0].telpro,
          mobilePro: data[0].mobilepro,
          phone1: data[0].phone1,
          phone2: data[0].phone2,
          office: data[0].signaletiqueOrienteur,
          affectations: data[0].supannEntiteAffectation,
          description: data[0].description,
          socialMedia: {
            linkedin: data[0].linkedin,
            hal: data[0].hal,
            twitter: data[0].twitter,
            youtube: data[0].video,
            url: data[0].url
          }                 
        })
      )
      .then(() => {
        if (this.state.buildingName === "Saclay-A") {
          this.setState({ buildingName: "Campus de Saclay - Bâtiment Eiffel" });
        } else if (this.state.buildingName === "Saclay-B") {
          this.setState({
            buildingName: "Campus de Saclay - Bâtiment Bouygues"
          });
        } else if (this.state.buildingName === "Saclay-S") {
          this.setState({
            buildingName: "Campus de Saclay - Bâtiment Bréguet"
          });
        }

        if (this.state.phone1 && this.state.phone1 !== this.state.telPro 
          && this.state.phone1 !== this.state.mobilePro) {
          this.setState({
            otherPhones: `${this.state.phone1}`
          });
        }
        if (this.state.phone2 && this.state.phone2 !== this.state.telPro 
          && this.state.phone2 !== this.state.mobilePro && this.state.phone2 !== this.state.phone1) {
            if (this.state.otherPhones === "") {
              this.setState({
                otherPhones: `${this.state.phone2}`
              });
            } else {
              this.setState({
                otherPhones: this.state.otherPhones + `, ${this.state.phone2}`
              });
            }          
        }

        // sanitize url
        // linkedin
        if (this.state.socialMedia.linkedin && this.state.socialMedia.linkedin.lastIndexOf('https://') !== 0
          && this.state.socialMedia.linkedin.lastIndexOf('http://') !== 0) {
          this.setState({
            socialMedia: {
              linkedin: `https://${this.state.socialMedia.linkedin}`,
              hal: this.state.socialMedia.hal,
              twitter: this.state.socialMedia.twitter,
              youtube: this.state.socialMedia.youtube,
              url: this.state.socialMedia.url
            }
          });
        }

        // HAL
        if (this.state.socialMedia.hal) {
          this.setState({
            socialMedia: {
              linkedin: this.state.socialMedia.linkedin,
              hal: `https://hal.archives-ouvertes.fr/search/index/?q=*&authIdHal_s=${this.state.socialMedia.hal}`,
              twitter: this.state.socialMedia.twitter,
              youtube: this.state.socialMedia.youtube,
              url: this.state.socialMedia.url
            }
          });
        }
        

        // twitter
        if (this.state.socialMedia.twitter.lastIndexOf("@") === 0) {
          this.setState({
            socialMedia: {
              linkedin: this.state.socialMedia.linkedin,
              hal: this.state.socialMedia.hal,
              twitter: `https://twitter.com/${this.state.socialMedia.twitter.substring(1)}`,
              youtube: this.state.socialMedia.youtube,
              url: this.state.socialMedia.url
            }
          });
        } else if (this.state.socialMedia.twitter && this.state.socialMedia.twitter.lastIndexOf("https://twitter.com/") !== 0) {
          this.setState({
            socialMedia: {
              linkedin: this.state.socialMedia.linkedin,
              hal: this.state.socialMedia.hal,
              twitter: this.state.socialMedia.twitter,
              youtube: this.state.socialMedia.youtube,
              url: this.state.socialMedia.url
            }
          });
        }

        // youtube
        if (this.state.socialMedia.youtube && this.state.socialMedia.youtube.lastIndexOf('https://') !== 0
          && this.state.socialMedia.youtube.lastIndexOf('http://') !== 0) {
          this.setState({
            socialMedia: {
              linkedin: this.state.socialMedia.linkedin,
              hal: this.state.socialMedia.hal,
              twitter: this.state.socialMedia.twitter,
              youtube: `https://${this.state.socialMedia.youtube}`,
              url: this.state.socialMedia.url
            }
          });
        }

        // url
        if (this.state.socialMedia.url && this.state.socialMedia.url.lastIndexOf('https://') !== 0
          && this.state.socialMedia.url.lastIndexOf('http://') !== 0) {
          this.setState({
            socialMedia: {
              linkedin: this.state.socialMedia.linkedin,
              hal: this.state.socialMedia.hal,
              twitter: this.state.socialMedia.twitter,
              youtube: this.state.socialMedia.youtube,
              url: `https://${this.state.socialMedia.url}`
            }
          });
        }
      })
      .catch(error => console.error(error));
  };

  render() {
    return (
      <div className="container">
        <Segment>
          <Grid stackable divided padded centered column={2}>
            <Grid.Row>
              <Grid.Column verticalAlign="middle" width={6}>
                <Presentation photoUrl={this.state.photoUrl} name={this.state.name} />
              </Grid.Column>
              <Grid.Column width={10}>
                {this.state.title && <Item icon="briefcase" info={this.state.title} />}
                {this.state.buildingName && <Item icon="building" info={this.state.buildingName} />}
                {this.state.office && <Item icon="archive" info={this.state.office} />}
                {this.state.affectations && <Item icon="group" info={this.state.affectations} />}
                {this.state.mail && <Item icon="mail" info={this.state.mail} />}
                {this.state.telPro && <Item icon="phone" info={this.state.telPro} />}          
                {this.state.mobilePro && <Item icon="phone" info={this.state.mobilePro} />}
                {this.state.otherPhones && <Item icon="phone" info={this.state.otherPhones} />} 
              </Grid.Column>
            </Grid.Row>
            {this.state.description &&
              <React.Fragment>
                <Grid.Row only="computer tablet">
                  <Grid.Column stretched>
                    <Divider />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row only="computer tablet">
		              <Grid.Column stretched>
		                <div class="custom-description-computer-tablet">
		                  {this.state.description}
		                </div>
		              </Grid.Column>
                </Grid.Row>
                <Grid.Row only="mobile">
		              <Grid.Column stretched>
		                <div class="custom-description-mobile">
		                  {this.state.description}
		                </div>
		              </Grid.Column>
                </Grid.Row>
              </React.Fragment>}
            {(this.state.socialMedia.linkedin || this.state.socialMedia.twitter || this.state.socialMedia.url 
              || this.state.socialMedia.youtube) &&
              <React.Fragment>
                <Grid.Row only="computer tablet">
                  <Grid.Column stretched>
                    <Divider />
                  </Grid.Column>
                </Grid.Row>
	              <Grid.Row className="custom-social-media-bar">
	                <Grid.Column verticalAlign="middle" stretched>
	                  <SocialMedia socialMedia={this.state.socialMedia} />
	                </Grid.Column>
	              </Grid.Row>
              </React.Fragment>}
          </Grid>
        </Segment>
      </div>
    );
  }
}

export default ProfilPage;



// WEBPACK FOOTER //
// ./src/scenes/ProfilPage/index.js